// Mini gráfica de línea para las tarjetas de estadística (SVG ligero, sin dependencias). `color`: el valor (es SVG, no lleva
// nombres del tema); sin él, el azul medio del tema.
import { useTheme } from '@mui/material/styles';

const Sparkline = ({ data = [], color, height = 44 }) => {
  const theme = useTheme();
  const trazo = color || theme.palette.secondary.main;
  if (!data.length) return null;

  const w = 100;
  const h = height;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const step = data.length > 1 ? w / (data.length - 1) : w;

  const pts = data.map((v, i) => [i * step, h - ((v - min) / range) * (h - 8) - 4]);
  const line = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
  const area = `${line} L${w},${h} L0,${h} Z`;

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h} preserveAspectRatio="none">
      <path d={area} fill={trazo} opacity="0.12" />
      <path d={line} fill="none" stroke={trazo} strokeWidth="2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export default Sparkline;
